/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetDisputeGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export type GetDisputeRequest = {
  accountID: string;
  disputeID: string;
};

export type GetDisputeResponse = {
  headers: { [k: string]: Array<string> };
  result: components.Dispute;
};

/** @internal */
export const GetDisputeGlobals$inboundSchema: z.ZodType<
  GetDisputeGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type GetDisputeGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const GetDisputeGlobals$outboundSchema: z.ZodType<
  GetDisputeGlobals$Outbound,
  z.ZodTypeDef,
  GetDisputeGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function getDisputeGlobalsToJSON(
  getDisputeGlobals: GetDisputeGlobals,
): string {
  return JSON.stringify(
    GetDisputeGlobals$outboundSchema.parse(getDisputeGlobals),
  );
}
export function getDisputeGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<GetDisputeGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetDisputeGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetDisputeGlobals' from JSON`,
  );
}

/** @internal */
export const GetDisputeRequest$inboundSchema: z.ZodType<
  GetDisputeRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  accountID: z.string(),
  disputeID: z.string(),
});
/** @internal */
export type GetDisputeRequest$Outbound = {
  accountID: string;
  disputeID: string;
};

/** @internal */
export const GetDisputeRequest$outboundSchema: z.ZodType<
  GetDisputeRequest$Outbound,
  z.ZodTypeDef,
  GetDisputeRequest
> = z.object({
  accountID: z.string(),
  disputeID: z.string(),
});

export function getDisputeRequestToJSON(
  getDisputeRequest: GetDisputeRequest,
): string {
  return JSON.stringify(
    GetDisputeRequest$outboundSchema.parse(getDisputeRequest),
  );
}
export function getDisputeRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetDisputeRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetDisputeRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetDisputeRequest' from JSON`,
  );
}

/** @internal */
export const GetDisputeResponse$inboundSchema: z.ZodType<
  GetDisputeResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
  Result: components.Dispute$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
    "Result": "result",
  });
});
/** @internal */
export type GetDisputeResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
  Result: components.Dispute$Outbound;
};

/** @internal */
export const GetDisputeResponse$outboundSchema: z.ZodType<
  GetDisputeResponse$Outbound,
  z.ZodTypeDef,
  GetDisputeResponse
> = z.object({
  headers: z.record(z.array(z.string())),
  result: components.Dispute$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
    result: "Result",
  });
});

export function getDisputeResponseToJSON(
  getDisputeResponse: GetDisputeResponse,
): string {
  return JSON.stringify(
    GetDisputeResponse$outboundSchema.parse(getDisputeResponse),
  );
}
export function getDisputeResponseFromJSON(
  jsonString: string,
): SafeParseResult<GetDisputeResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetDisputeResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetDisputeResponse' from JSON`,
  );
}
